import classes from "./NoMediaFound.module.less";
import { Button } from "~/common/mui";
import { useFormContext } from "react-hook-form";
import type { MediaFormFields } from "~/features/mediaLibrary/types/mediaLibraryFormTypes";
import { IMG_NO_RESULTS_OR_MATCHES } from "~/utils/url/staticResources";
import { useTranslation } from "react-i18next";

export default function NoMediaFound() {
  const { watch, reset } = useFormContext<MediaFormFields>();
  const fetchFavourite = watch("fetchFavourite");
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <h1 className={classes.headline}>
        {fetchFavourite ? t("media.library.noFavouritesFound") : t("media.library.noMatchesFound")}
      </h1>
      <p className={classes.description}>{t("media.library.noMatchesTryAgain")}</p>
      <img
        src={IMG_NO_RESULTS_OR_MATCHES}
        alt={t("media.library.filterLabel.imageError")}
        className={classes.graphic}
      />
      <Button variant="text" className={classes.btn} onClick={() => reset()}>
        {fetchFavourite ? t("media.library.backToLibrary") : t("media.library.resetFilters")}
      </Button>
    </div>
  );
}
